//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PackageStatus, PackageVisibility, PackageExpiryType } from './Enums';

export class PackageDefinitionInputItem extends ItemBase {
    Name: string | null = null;
    Description: string | null = null;
    Price: number = 0;
    Duration: number = 0;
    Status: PackageStatus = PackageStatus.Active;
    Visibility: PackageVisibility = PackageVisibility.None;
    ExpiryType: PackageExpiryType = PackageExpiryType.None;
    DaysToExpire: number | null = null;
    ShowDiscount: boolean = false;
    TagIDs: string[] = [];

    constructor(initializer?: Partial<PackageDefinitionInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PackageDefinitionInputItem";
}
